// extracted by mini-css-extract-plugin
export default {"main_flex":"SingleProductPage_main_flex__kJX3c","inner_flex":"SingleProductPage_inner_flex__dc9LP","Button_flex":"SingleProductPage_Button_flex__7OAOI"};